<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="$vuetify.lang.t('$vuetify.SETTINGS.OPERATOR_SETTINGS')"
      :breadcrumbs="[
        {
          text: $vuetify.lang.t(
            '$vuetify.SETTINGS.OPERATOR_SETTINGS_DESCRIPTION'
          ),
          disabled: true
        }
      ]"
    />
    <v-col>
      <div class="text--primary pb-2">{{ $vuetify.lang.t('ZONES') }}</div>
      <v-card class="elevation-3">
        <v-toolbar class="elevation-0 col">
          <v-row justify="end">
            <v-btn v-if="isGlobalAdmin" color="white" small @click="editZone()">
              <v-icon class="success--text">mdi-plus</v-icon>
              {{ $vuetify.lang.t('$vuetify.SETTINGS.ADD_NEW_ZONE') }}
            </v-btn>
          </v-row>
        </v-toolbar>
        <v-row>
          <v-col class="pa-6">
            <v-data-table
              :items="zones"
              :headers="headers"
              hide-default-footer
              :no-data-text="$vuetify.lang.t('$vuetify.SETTINGS.NO_ZONES')"
              :items-per-page="-1"
              :loading="loading.state && loading.type === 'getZones'"
            >
              <template v-slot:item.Name="props">
                <v-row>
                  <v-col>{{ props.item.Name || props.item.Code || '-' }}</v-col>
                  <v-col class="text-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-if="isGlobalAdmin"
                          icon
                          color="primary"
                          small
                          outlined
                          v-on="on"
                          @click.stop="editZone(props.item)"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>
                        {{ $vuetify.lang.t('$vuetify.EDIT') }}
                      </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OperatorSettings',
  data() {
    return {
      headers: [
        {
          text: this.$vuetify.lang.t('$vuetify.NAME'),
          i18n: 'NAME',
          value: 'Name',
          guarded: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('authentication', ['isGlobalAdmin']),
    ...mapGetters('zones', ['zones'])
  },
  created() {
    this.getZones()
  },
  methods: {
    ...mapActions('zones', ['getZones']),
    editZone(item) {
      this.$router.push(`/zone/${item ? item.ID : 0}`)
    }
  }
}
</script>
